module.exports = __webpack_public_path__ + "img/thumb-carly-off.93f6480b.jpg";